import Footer from "components/footer/FooterAuthDefault";
import authImg from "assets/img/logo.png";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

export default function Auth() {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div>
      <div className="relative min-h-screen w-full !bg-white dark:!bg-navy-900">
        <FixedPlugin />
        <main className="mx-auto min-h-screen max-w-md px-4">
          <div className="flex min-h-screen flex-col items-center justify-between py-8">
            {/* Logo at the top */}
            <div className="flex w-full justify-center pt-8">
              <img
                src={authImg}
                alt="PituLab Logo"
                className="max-h-25 object-contain"
              />
            </div>

            {/* Auth form in the middle */}
            <div className="w-full">
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={<Navigate to="/auth/sign-in" replace />}
                />
              </Routes>
            </div>

            {/* Footer at the bottom */}
            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
}
